module.exports = {
  REST: require('./rest'),
  TaskAPI: require('./task')
};